<template>
  <FormulateInput :type="type" v-bind="$attrs" :key="value" :value="value" @option:selecting="$emit('option:selecting', $event)" @option:selected="$emit('option:selected', $event)" @input="$emit('input', $event)">
    <template #prefix>
      <div class="formulate-input-prefix">
        <slot name="prefix"></slot>
      </div>
    </template>
    <template #suffix>
      <div class="formulate-input-suffix">
        <slot name="suffix"></slot>
      </div>
    </template>
  </FormulateInput>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: String,
    },
  },
};
</script>

<style lang="postcss" scoped>
/deep/ .formulate-input {
  &-element {
    @apply flex items-center bg-neutral-white border-solid border-hairline border-neutral-semilight rounded-md;

    &--group {
      @apply flex flex-col gap-micro;
    }
    [data-is-showing-errors='true']& {
      @apply border-feedback-error-medium;
    }
  }
  &-prefix,
  &-suffix {
    @apply px-nano py-micro style-body-sm;
  }
}
.formulate-input::v-deep {
  input {
    @apply w-full px-quark border-none text-neutral-ultradark py-micro disabled:bg-neutral-lightest style-body-sm focus:outline-none;
  }
}
</style>
